import { render, staticRenderFns } from "./QHzhuce.vue?vue&type=template&id=bad00594"
import script from "./QHzhuce.vue?vue&type=script&lang=js"
export * from "./QHzhuce.vue?vue&type=script&lang=js"
import style0 from "./QHzhuce.vue?vue&type=style&index=0&id=bad00594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports